module.exports = __webpack_public_path__ + "media/images/flash-error-2c0eee7a14a02428e888db2f998a8aba.svg";